import React, { useEffect, useState } from 'react';
import { Button,Container, IconButton, Grid, FormGroup, TextField, Typography, FormHelperText,FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from './api'; // api.js をインポート
import PdfModalViewer from './PdfModalViewer.js';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import { useNavigationHistory } from './common/navigationHistory.js';
import BackButton from './common/BackButton.js';
import HamburgerMenu from './components/Hamburger.jsx';
import Header from "./components/Header.jsx";

const Comp16Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
    const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null); 
    const [mypageData, setMypageData] = useState(null);
    console.log(mypageData)
    const navigate = useNavigate();
    const location = useLocation();
    const [notApply, setNotApply] = useState(false);
    const createFoodDetail = () => ({
      food_item: '',
      food_sales_method: '',
      food_price: '',
      food_quantity: '',
      food_price_all: '',
      food_warranty_method: '',
      hygiene_management: '',
    });

    const createSubDetail = () => ({
      sales_item_name: '',
      tasting: false,
      tasting_notes: '',
      sample_distribution: false,
      sample_distribution_notes: '',
      equipment_installed: '',
    });
    const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
    const [formData, setFormData] = useState({
      user_16_name: "",
      user_16_department: "",
      user_16_phone: "",
      user_16_tel: "",
      onsite_manager_company: '',
      onsite_manager_name: '',
      onsite_manager_phone: '',
      food_price_all_contains: '',
      post_event_sales_responsible: '',
      post_event_manager_company: '',
      post_event_manager_name: '',
      post_event_manager_phone: '',
      alfa_text: '',
      details: [createFoodDetail()],
      sub_details: [createSubDetail()]
    });
    const [corrections, setCorrections] = useState({
      user_16_info: false,
      onsite_manager_info: false,
      post_manager_info: false,
      tasting: false,
      sample_distribution: false,
      details: false,
    });
  
    const field_name_map = {
      user_16_info: "担当者情報",
      onsite_manager_info: "現場管理責任者情報",
      post_manager_info: "会期後管理責任者情報",
      tasting: "試食",
      sample_distribution: "試供品",
      details: "販売食品詳細",
    };
    const [open, setOpen] = useState(false);
    const [memoText, setMemoText] = useState('');

    const handleCorrectionChange = (fieldKey) => (e) => {
      setCorrections(prev => ({
        ...prev,
        [fieldKey]: e.target.checked
      }));
    };

    const updateStatus = (exhibitorId, formType, updates) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                ...Object.fromEntries(
                  Object.entries(updates).map(([role, status]) => [
                    `${formType}_${role}_status`,
                    status,
                  ])
                ),
              }
            : ex
        )
      );
    };

    const handleSubDetailBooleanChange = (index, field) => (e) => {
      let value = e.target.value;

      if (value === "true") value = true;
      if (value === "false") value = false;

      handleArrayChange("sub_details", index, field, value);
    };

    const handleCorrection = async () => {
      try {
        const selectedFields = Object.entries(corrections)
          .filter(([_, checked]) => checked)
          .map(([field]) => field_name_map[field] || field);

        if (selectedFields.length === 0) {
          alert('修正対象の項目を選択してください');
          return;
        }

        const currentPath = window.location.pathname;

        await api.patch('/api/host-correction', {
          exhibitor_id: exhibitorId,
          form_type: 'o16',
          correction: selectedFields,
          memo: memoText,
          current_path: currentPath,
        });

        // 👇 これ追加
        updateStatus(exhibitorId, 'o16', {
          host: '未確認',
          corporate: '未確認',
        });

        alert('修正リクエスト送信完了');
        setFormModalOpen(false);

        setCorrections(
          Object.fromEntries(Object.keys(corrections).map(k => [k, false]))
        );
        setMemoText('');

      } catch (err) {
        console.error(err);
        alert('修正処理でエラーが発生しました');
      }
    };

    const updateHostStatus = (exhibitorId, formType, newStatus) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                [`${formType}_host_status`]: newStatus,
                [`${formType}_corporate_status`]: newStatus, // ←これ追加
              }
            : ex
        )
      );
    };

    // 確認済み
    const handleConfirm = async () => {
      try {
        const res = await api.patch('/api/forms/confirm', {
          exhibitor_id: exhibitorId,
          form_type: selectedFormKey,
          role: "host"
        });
        
        updateHostStatus(exhibitorId, selectedFormKey,'確認済');

        alert('確認済みに更新しました');
        setFormModalOpen(false);
      } catch (err) {
        console.error(err);
        alert('確認処理でエラー');
      }

      console.log('送信データ', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });
    };

    useEffect(() => {
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }
  
      const userData = localStorage.getItem("user");
  
      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
        } else {
          console.warn("exhibitor_id が見つかりません");
        }
      } else {
        console.warn("localStorageにuserが存在しません");
      }
    }, [location, isModal, isCorpModal, propExhibitorId]);

    const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  
    
    const handleChange = (field) => (e) => {
      let value =
        e.target.type === "checkbox"
          ? e.target.checked
          : e.target.value;

      if (value === "true") value = true;
      if (value === "false") value = false;

      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    const [formErrors, setFormErrors] = useState({}); // フィールドごとのエラーを保持

    const isInteger = (val) => /^[0-9]+$/.test(val);

    const handleArrayChange = (key, index, field, value) => {
      const updated = [...formData[key]];
      let errorMsg = "";

      // 数値フィールドのときだけ整数チェック
      if (["food_price", "food_quantity"].includes(field)) {
        if (value === "" || isInteger(value)) {
          // OK → 数値化（空文字は空のまま）
          updated[index][field] = value === "" ? "" : Number(value);
        } else {
          // NG → 値はそのまま保持してエラーメッセージ
          updated[index][field] = value;
          errorMsg = "半角数字（整数）のみ入力してください";
        }
      } else {
        // 文字列系フィールドはそのまま
        updated[index][field] = value;
      }

      // 合計を自動計算
      if (
        key === "details" &&
        ["food_price", "food_quantity"].includes(field)
      ) {
        const price = Number(updated[index].food_price) || 0;
        const quantity = Number(updated[index].food_quantity) || 0;

        updated[index].food_price_all =
          price === 0 || quantity === 0 ? "" : price * quantity;
      }

      setFormData({
        ...formData,
        [key]: updated,
      });

      // エラーを更新
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        if (errorMsg) {
          newErrors[`${key}_${index}_${field}`] = errorMsg;
        } else {
          delete newErrors[`${key}_${index}_${field}`];
        }
        return newErrors;
      });
    };

    const handleAdd = (key, initial = {}) => {
      setFormData({ ...formData, [key]: [...formData[key], initial] });
    };

    const handleDelete = (key, index) => {
      if ((formData[key] || []).length <= 1) {
        return;
      }

      const updated = [...formData[key]];
      updated.splice(index, 1);

      setFormData({
        ...formData,
        [key]: updated,
      });
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const user = JSON.parse(localStorage.getItem('user'));
          const res = await api.get(`/api/mypage/${exhibitorId}`);
          setMypageData(res.data);
        } catch (err) {
          console.error("データ取得エラー:", err);
        }
      };
      fetchData();
    }, []);

    const [fieldsDisabled, setFieldsDisabled] = useState(false);

    const handleSameAsExhibitor = (value) => {
      setSameAsExhibitor(value);

      if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
          ...prev,
          user_16_name: mypageData.user_name || "",
          user_16_department: mypageData.department || "",
          user_16_phone: mypageData.phone_number || "",
          user_16_tel: mypageData.tel_number || "",
        }));
        setFieldsDisabled(true);
      } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
          ...prev,
          user_16_name: "",
          user_16_department: "",
          user_16_phone: "",
          user_16_tel: "",
        }));
        setFieldsDisabled(false);
      }
    };
    // Comp16fetch
   useEffect(() => {
    const fetchO16InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO16, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o16submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o16Status = resStatus.data?.o16_status || "";
        const o16Data = resO16.data || {};
        console.log(o16Data)
        const mypage = resMypage.data || {};

        if (o16Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_16_name: null,
            user_16_department: null,
            user_16_phone: null,
            user_16_tel: null,
            onsite_manager_company: null,
            onsite_manager_name: null,
            onsite_manager_phone: null,
            food_price_all_contains: null,
            food_warranty_method: null,
            hygiene_management: null,
            post_event_sales_responsible: null,
            post_event_manager_company: null,
            post_event_manager_name: null,
            post_event_manager_phone: null,
            // manager_name: null,
            sales_item_name: null,
            tasting: null,
            tasting_notes: null,
            sample_distribution: null,
            sample_distribution_notes: null,
            equipment_installed: null,
            // tableware: null,
            alfa_text: null,
            details: [createFoodDetail()],
            sub_details: [createSubDetail()],          
            });
        } else {
            if (Object.values(o16Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o16Data,
                details: o16Data.details?.length
                  ? o16Data.details
                  : [createFoodDetail()],

                sub_details: o16Data.sub_details?.length
                  ? o16Data.sub_details
                  : [createSubDetail()],
            }));
            if (
              o16Data.user_16_name === mypage.user_name &&
              o16Data.user_16_department === mypage.department &&
              o16Data.user_16_phone === mypage.phone_number &&
              o16Data.user_16_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O16初期データ取得エラー:", err);
        }
    };

    fetchO16InitialData();
    }, []);

  const [foodError, setFoodError] = useState('');

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_16_name: '',
            user_16_department: '',
            user_16_phone: '',
            user_16_tel: '',
            onsite_manager_company: '',
            onsite_manager_name: '',
            onsite_manager_phone: '',
            food_price_all_contains: '',
            food_warranty_method: '',
            hygiene_management: '',
            post_event_sales_responsible: '',
            post_event_manager_company: '',
            post_event_manager_name: '',
            post_event_manager_phone: '',
            // manager_name: '',
            sales_item_name: '',
            tasting: false,
            tasting_notes: '',
            sample_distribution: false,
            sample_distribution_notes: '',
            equipment_installed: '',
            // tableware: '',
            alfa_text: '',
            details: [createFoodDetail()],
            sub_details: [createSubDetail()],
          });
      }
  };

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
    // { label: 'INDEX', path: '/INDEX.pdf' },
    { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
    // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
    // { label: '出展者証について', path: '/出展者証について.pdf' },
    // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
    // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
    // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
    // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
    // { label: '出展者一覧', path: '/出展者一覧.pdf' },
    // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
    // { label: '運送関連', path: '/運送関連.zip' },
    // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
    // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
  ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  const [noticeModalOpen, setNoticeModalOpen] = useState(false);
  const [ submitErrors, setSubmitErrors] = useState({});

  const [openPop, setOpenPop] = useState(false);

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const sanitizeFormData = (data) => {
        if (Array.isArray(data)) {
          return data.map(sanitizeFormData);
        } else if (typeof data === "object" && data !== null) {
          const newObj = {};
          for (const [key, value] of Object.entries(data)) {
            if (value === "") {
              newObj[key] = null;
            }
            // --- 数値フィールド ---
            else if (
              [
                "food_price_all_contains",
                "food_price",
                "food_quantity",
                "food_price_all",
              ].includes(key)
            ) {
              newObj[key] =
                value !== null && value !== "" && !isNaN(Number(value))
                  ? Number(value)
                  : null;
            }
            // --- 文字列フィールド ---
            else if (
              [
                "user_16_name",
                "user_16_department",
                "user_16_phone",
                "user_16_tel",
                "onsite_manager_company",
                "onsite_manager_name",
                "onsite_manager_phone",
                "food_warranty_method",
                "hygiene_management",
                "post_event_sales_responsible",
                "post_event_manager_company",
                "post_event_manager_name",
                "post_event_manager_phone",
                // "manager_name",
                "sales_item_name",
                "tasting_notes",
                "sample_distribution_notes",
                "equipment_installed",
                // "tableware",
                "alfa_text",
                "food_item",
                "food_sales_method",
                "sales_item_name",
                "tasting_notes",
                "sample_distribution_notes",
                "equipment_installed",
              ].includes(key)
            ) {
              newObj[key] = value != null ? String(value) : null;
            }
            // --- 再帰 ---
            else {
              newObj[key] = sanitizeFormData(value);
            }
          }
          return newObj;
        }
        return data;
      };

      // 合計金額を計算
      const totalAmount = formData.details.reduce((sum, item) => {
        return sum + (Number(item.food_price_all) || 0);
      }, 0);

      // formDataにセット
      const submitData = {
        ...formData,
        food_price_all_contains: totalAmount,
      };

      const normalizedDetails = (formData.details || []).filter(
        (item) =>
          item?.food_item?.trim() ||
          item?.food_sales_method?.trim() ||
          item?.food_warranty_method?.trim() ||
          item?.hygiene_management?.trim() ||
          item?.food_price !== '' ||
          item?.food_quantity !== ''
      );

      const normalizedSubDetails = (formData.sub_details || []).filter(
        (item) =>
          item?.sales_item_name?.trim() ||
          item?.tasting === true ||
          item?.tasting_notes?.trim() ||
          item?.sample_distribution === true ||
          item?.sample_distribution_notes?.trim() ||
          item?.equipment_installed?.trim()
      );

      const sanitizedFormData = sanitizeFormData({
        ...submitData,
        details: normalizedDetails,
        sub_details: normalizedSubDetails,
      });
      const submitErrors = {};

      if (!notApply) {
        // 基本必須項目チェック
        if (!formData.user_16_name?.trim())
          submitErrors.user_16_name = "入力してください";
        if (!formData.user_16_phone?.trim())
          submitErrors.user_16_phone = "入力してください";
        if (!formData.user_16_tel?.trim())
          submitErrors.user_16_tel = "入力してください";
        // if (!normalizedDetails.length) {
        //   submitErrors.details = "販売する食品を1件以上入力してください";
        // }
      }

      const fieldDisplayNames = {
        user_16_name: "担当者名",
        user_16_department: "担当部署",
        user_16_phone: "担当者携帯",
        user_16_tel: "担当者電話",
        details: "販売食品詳細",
      };

      if (Object.keys(submitErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: sanitizedFormData,
        notApply: notApply,
      };

      console.log(payload)

      const res = await api.post("/api/submit-o16", payload);
      
      if (res.status === 200) {
        alert("保存成功");
      } else {
        alert("保存失敗");
      }

      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          if (user?.user_id === 0) {
            navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
          } else {
            navigate(`/mypage/${user?.mypage_id}`);
          }
        }
      }, 1000);
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };
  const user = JSON.parse(localStorage.getItem("user"));
  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://ex-link.net'; // 本番 HTTPS

return(
  <>
  <div sx={{mx: 0, px: 0 , width: '100%'}}>
    {!isCorpModal &&(
      <Header
        title="しんきんビジネスマッチング　ビジネスフェア2026 防炎対象物品申請"
        companyName={mypageData?.company_name}
      />
    )}
    <style>
    {`
    @media only screen and (max-width: 560px) {
    .sm-block {display: block;}
    .sm-none {display: none;}
    .sm-column {flex-direction: column;}
    .noti-cate {font-size: 18px;}
    .timestamp {font-size: 14px;}
    .info {font-size: 14px;}
    .f-16 {font-size: 16px;}
    }
    @media only screen and (min-width: 561px) {
    .hamburger_menu_btn_wrap {display: none;}
    }
    `}
    </style>
    <Container sx={{ display: 'flex' }}>
      {!isCorpModal &&(
      <>
      <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box
              className={`menu-item`}
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`${user?.mypage_url}`);
              }}
            >
              TOP
            </Box>
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`/mypage-info/${user?.exhibitor_id}`);
              }}
            >
              出展者情報編集
            </Box>
            {/* <Box
              className="menu-group"
              id="hover-block"
              onMouseEnter={() => {}}
              onMouseLeave={() => {}}
            >
              <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                申請フォーム
              </Box>
                {showFormMenu && (
                  <Box className="hover-menu">
                    <Typography
                      sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00111BC', pb: 1 }}
                      className='form-button'
                      onClick={() => navigate('/form-require')}
                    >
                      必須フォーム<br />
                      (全出展者対象)
                    </Typography>
                    <Typography
                      sx={{ color: '#00111bc', textAlign: 'center', pt: 1 }}
                      className='form-button'
                      onClick={() => navigate('/form-optional')}
                    >
                      任意フォーム<br />
                      (該当出展者対象)
                    </Typography>
                  </Box>
                )}
            </Box> */}
            <Box 
              className="menu-item"
              onClick={() => {
                navigate('/mail-form/');
              }}
            >
              お問い合わせ
            </Box>
            {renderMenuItems()}
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const mypage = user?.mypage_url;

                handleScrollTo('news', mypage);
              }}
            >
              お知らせ
            </Box>
            <Box
              className="menu-item"
              onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
            >
              個人情報保護方針
            </Box>
          </Box>
        </Box>
        <BackButton />
      </Container>
      <HamburgerMenu />
      </>
      )}
      {!!changeModalOpen &&(
        <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
          <Typography variant="h6" gutterBottom>
            修正内容のメモ
          </Typography>
          <TextField
            multiline
            rows={20}
            fullWidth
            placeholder="ここに修正内容を書いてください..."
            value={memoText}
            onChange={(e) => setMemoText(e.target.value)}
          />
          <Box>
            <Typography variant="h6">マイページ情報</Typography>
            {mypageData ? (
              <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                <Typography variant="body1">部署: {mypageData.department}</Typography>
                <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                <Typography variant="body1">住所: {mypageData.address}</Typography>
                <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
              </Box>
            ) : (
              <Typography variant="body2">読み込み中...</Typography>
            )}
          </Box>
        </Box>
      )}
      <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">食品取扱関係調査票・食品販売申込</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
          <FormControlLabel
          control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
          label="申請しない"
          />
          {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography color='error' variant='caption'>
                ※食品の販売を行う場合にこちらの申請フォームにご記入ください。<br />
              　試飲・試食・試供品の配布を行う場合は申請フォームIにご記入ください。
              </Typography>
              <Box>
                <Button variant="outlined" onClick={() => setOpen(true)}>出展概要該当ページを表示する</Button>
              </Box>
              <PdfModalViewer
                filePath="/しんきんビジネスフェア2026出展概要_0709.pdf"
                isOpen={open}
                onClose={() => setOpen(false)}
                startPage={28}
                endPage={32}
              />
              <Box>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.user_16_info}
                        onChange={handleCorrectionChange( 'user_16_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="担当者情報"
                  />
                )}
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_16_name" value={formData.user_16_name} disabled={fieldsDisabled} onChange={handleChange("user_16_name")} error={!!submitErrors.user_16_name} helperText={submitErrors.user_16_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_16_department" value={formData.user_16_department} disabled={fieldsDisabled} onChange={handleChange("user_16_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_16_phone" value={formData.user_16_phone} disabled={fieldsDisabled} onChange={handleChange("user_16_phone")} error={!!submitErrors.user_16_phone} helperText={submitErrors.user_16_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_16_tel" value={formData.user_16_tel} disabled={fieldsDisabled} onChange={handleChange("user_16_tel")} error={!!submitErrors.user_16_tel} helperText={submitErrors.user_16_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
                <Box>
                <Box>
                  <Typography variant='h6'>食品取扱関係調査票</Typography>
                  {/* <TextField
                      label="管理責任者"
                      name="manager_name"
                      value={formData.manager_name}
                      onChange={handleChange("manager_name")}
                      correctionChecked={corrections.safe_manager || false}
                      onCorrectionChange={handleCorrectionChange("safe_manager")}
                      isModal={isModal}
                      fullWidth
                      sx={{ mb: 2 }}
                  /> */}
                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.tasting}
                          onChange={handleCorrectionChange( 'tasting')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="試食・試飲等"
                    />
                  )}
                  <Typography variant='p'>試食・試飲および試供品提供申込</Typography>
                  {formData.sub_details.map((item, index) => (
                    <Box
                      key={`sub-detail-${index}`}
                      sx={{
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        p: 2,
                        mb: 2
                      }}
                    >
                      <TextField
                        label="品名"
                        value={item.sales_item_name}
                        onChange={(e) =>
                          handleArrayChange(
                            "sub_details",
                            index,
                            "sales_item_name",
                            e.target.value
                          )
                        }
                        fullWidth
                        sx={{ mb: 2 }}
                      />

                      <TextField
                        label="設置する設備"
                        value={item.equipment_installed}
                        onChange={(e) =>
                          handleArrayChange(
                            "sub_details",
                            index,
                            "equipment_installed",
                            e.target.value
                          )
                        }
                        fullWidth
                        sx={{ mb: 2 }}
                      />

                      <FormLabel>試食・試飲</FormLabel>

                      <RadioGroup
                        row
                        value={item.tasting}
                        onChange={handleSubDetailBooleanChange(index, "tasting")}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="あり" />
                        <FormControlLabel value="false" control={<Radio />} label="なし" />
                      </RadioGroup>

                      {item.tasting === true && (
                        <TextField
                          label="試食・試飲等内容"
                          value={item.tasting_notes}
                          onChange={(e) =>
                            handleArrayChange(
                              "sub_details",
                              index,
                              "tasting_notes",
                              e.target.value
                            )
                          }
                          fullWidth
                          sx={{ mb: 2 }}
                        />
                      )}

                      <FormLabel>試供品</FormLabel>

                      <RadioGroup
                        row
                        value={item.sample_distribution}
                        onChange={handleSubDetailBooleanChange(index, "sample_distribution")}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="あり" />
                        <FormControlLabel value="false" control={<Radio />} label="なし" />
                      </RadioGroup>

                      {item.sample_distribution === true && (
                        <>
                          <TextField
                            label="試供品内容"
                            value={item.sample_distribution_notes}
                            onChange={(e) =>
                              handleArrayChange(
                                "sub_details",
                                index,
                                "sample_distribution_notes",
                                e.target.value
                              )
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                          />
                        </>
                      )}

                      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start' }}>
                        <Button
                          startIcon={<Delete />}
                          color="error"
                          onClick={() => handleDelete("sub_details", index)}
                          disabled={formData.sub_details.length <= 1}
                        >
                        </Button>

                        <Button
                          startIcon={<Add />}
                          onClick={() => handleAdd("sub_details", createSubDetail())}
                        >
                          追加
                        </Button>
                      </Box>
                    </Box>
                  ))}

                  {/* <TextField
                      label="食器具"
                      name="tableware"
                      value={formData.tableware}
                      onChange={handleChange("tableware")}
                      fullWidth
                      correctionChecked={corrections.tableware || false}
                      onCorrectionChange={handleCorrectionChange("tableware")}
                      isModal={isModal}
                      sx={{ mb: 2 }}
                  /> */}
                </Box>
                <Typography variant="p">現場管理責任者</Typography>

                <TextField
                    label="会社名"
                    name="onsite_manager_company"
                    value={formData.onsite_manager_company}
                    onChange={handleChange("onsite_manager_company")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.onsite_manager_company}
                    helperText={submitErrors.onsite_manager_company}
                />

                <TextField
                    label="担当者名"
                    name="onsite_manager_name"
                    value={formData.onsite_manager_name}
                    onChange={handleChange("onsite_manager_name")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.onsite_manager_name}
                    helperText={submitErrors.onsite_manager_name}
                />

                <TextField
                  label="電話番号"
                  name="onsite_manager_phone"
                  value={formData.onsite_manager_phone}
                  onChange={handleChange("onsite_manager_phone")}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!submitErrors.onsite_manager_phone}
                  helperText={submitErrors.onsite_manager_phone}
                />

                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.details}
                        onChange={handleCorrectionChange( 'details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="販売食品詳細"
                  />
                )}

                <Typography variant='h6'>食品販売申込</Typography>
                <Typography>販売する食品の詳細を入力してください。</Typography>

                {formData.details.map((item, index) => (
                  <React.Fragment key={index}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>品名</TableCell>
                            <TableCell>
                              提供方法
                              <span
                                style={{
                                  color: "#FFF",
                                  backgroundColor: "#000",
                                  borderRadius: "100%",
                                  padding: "2px 6px",
                                  cursor: "pointer",
                                }}
                                onClick={() => setOpenPop(true)}
                              >
                                ?
                              </span>
                            </TableCell>
                            <TableCell>価格</TableCell>
                            <TableCell>数量</TableCell>
                            <TableCell>合計</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <TextField
                                value={item.food_item}
                                onChange={(e) =>
                                  handleArrayChange(
                                    "details",
                                    index,
                                    "food_item",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!formErrors[`details_${index}_food_item`]}
                                helperText={formErrors[`details_${index}_food_item`]}
                              />
                            </TableCell>

                            <TableCell>
                              <TextField
                                value={item.food_sales_method}
                                onChange={(e) =>
                                  handleArrayChange(
                                    "details",
                                    index,
                                    "food_sales_method",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                sx={{ mb: 2 }}
                                error={
                                  !!formErrors[
                                    `details_${index}_food_sales_method`
                                  ]
                                }
                                helperText={
                                  formErrors[
                                    `details_${index}_food_sales_method`
                                  ]
                                }
                              />
                            </TableCell>

                            <TableCell>
                              <TextField
                                value={item.food_price}
                                onChange={(e) =>
                                  handleArrayChange(
                                    "details",
                                    index,
                                    "food_price",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!formErrors[`details_${index}_food_price`]}
                                helperText={
                                  formErrors[`details_${index}_food_price`]
                                }
                              />
                            </TableCell>

                            <TableCell>
                              <TextField
                                value={item.food_quantity}
                                onChange={(e) =>
                                  handleArrayChange(
                                    "details",
                                    index,
                                    "food_quantity",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!formErrors[`details_${index}_food_quantity`]}
                                helperText={
                                  formErrors[`details_${index}_food_quantity`]
                                }
                              />
                            </TableCell>

                            <TableCell>
                              <TextField
                                value={item.food_price_all}
                                fullWidth
                                sx={{ mb: 2 }}
                                slotProps={{
                                  input: {
                                    readOnly: true,
                                  },
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <Box sx={{ mt: 2 }}>
                      <TextField
                        label="商品保証方法（保証書発行、領収証発行、問い合わせ先明記 等）"
                        value={item.food_warranty_method}
                        onChange={(e) =>
                          handleArrayChange(
                            "details",
                            index,
                            "food_warranty_method",
                            e.target.value
                          )
                        }
                        fullWidth
                        sx={{ mb: 2 }}
                      />

                      <TextField
                        label="衛生管理方法（真空パック・冷蔵庫・手洗い・消毒装置 等）"
                        value={item.hygiene_management}
                        onChange={(e) =>
                          handleArrayChange(
                            "details",
                            index,
                            "hygiene_management",
                            e.target.value
                          )
                        }
                        fullWidth
                      />
                    </Box>

                    {formData.details.length >= 1 && (
                      <IconButton
                        onClick={() => handleDelete("details", index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </React.Fragment>
                ))}

                <Button
                  onClick={() =>
                    handleAdd("details", {
                      food_item: "",
                      food_sales_method: "",
                      food_price: "",
                      food_quantity: "",
                      food_price_all: "",
                    })
                  }
                  startIcon={<Add />}
                >
                  追加
                </Button>

                <Modal open={openPop} onClose={() => setOpenPop(false)}>
                    <Box
                      sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      bgcolor: 'white',
                      borderRadius: 2,
                      boxShadow: 24,
                      p: 4,
                      width: 480,
                      }}
                    >
                      <Typography variant="h7" gutterBottom>
                      出展概要のp.24をご確認の上、ご記入下さい。
                      </Typography>
                      <Box mt={2} textAlign="right">
                        <Button onClick={() => setOpenPop(false)} variant="contained">
                            閉じる
                        </Button>
                      </Box>
                    </Box>
                </Modal>
                </Box>

                <Box>
                <FormControl component="fieldset" sx={{ mt: 3 }} error={!!submitErrors.post_event_sales_responsible}>
                    <FormLabel component="legend">会期後販売責任者</FormLabel>
                    <RadioGroup
                    row
                    name="post_event_sales_responsible"
                    value={formData.post_event_sales_responsible}
                    onChange={handleChange("post_event_sales_responsible")}
                    >
                    {["現場管理責任者と同一", "現場管理責任者と異なる者"].map((plan) => (
                        <FormControlLabel key={plan} value={plan} control={<Radio />} label={plan} />
                    ))}
                    </RadioGroup>
                    {!!submitErrors.post_event_sales_responsible && (
                      <FormHelperText>{submitErrors.post_event_sales_responsible}</FormHelperText>
                    )}
                </FormControl>
                </Box>
                
                {formData.post_event_sales_responsible === "現場管理責任者と異なる者" && (
                <Box>
                <TextField
                    label="会社名"
                    name="post_event_manager_company"
                    value={formData.post_event_manager_company}
                    onChange={handleChange("post_event_manager_company")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.post_event_manager_company}
                    helperText={submitErrors.post_event_manager_company}
                />

                <TextField
                    label="担当者名"
                    name="post_event_manager_name"
                    value={formData.post_event_manager_name}
                    onChange={handleChange("post_event_manager_name")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.post_event_manager_name}
                    helperText={submitErrors.post_event_manager_name}
                />

                <TextField
                    label="電話番号"
                    name="post_event_manager_phone"
                    value={formData.post_event_manager_phone}
                    onChange={handleChange("post_event_manager_phone")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.post_event_manager_phone}
                    helperText={submitErrors.post_event_manager_phone}
                />
                </Box>
                )}
            </Box>
            </Box>
              <Box>
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※食品取扱関係調査票について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
              </Box>
            </>
          )}
        </FormGroup>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            ビジネスフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
      </Container>
    </Container>
    {!isCorpModal &&(
    <>
    <Container sx={{textAlign: 'center'}}>
        <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
            提出する
        </Button>
    </Container>
    <footer>
      <Typography>
        © 2026 THE MID-JAPAN ECONOMIST.
      </Typography>
    </footer>
    </>
    )}
    {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
    </>
)

};

export default Comp16Sub;
